<!--
 * @Author: DouDou
 * @LastEditors: DouDou
 * @Date: 2020-09-22 17:23:34
 * @LastEditTime: 2020-09-27 18:51:45
 * @Description: File description
-->
<template>
  <div class="withdraw">
    <img class="withdraw-nav" src="../assets/images/withdraw_nav.png" alt="">
    <p class="withdraw-explain">为保证奖励学费安全提现到账，请仔细阅读以下流程哦。</p>
    <ul class="withdraw-steps">
      <li>
        <div class="withdraw-padding">
          <h3 class="withdraw-step">01找到学费提现入口</h3>
          <p>请先关注学而思网校公众账号，点击菜单“我的网校” ------学费提现</p>
        </div>
        <img src="../assets/images/withdraw1.png" alt="">
      </li>
      <li>
        <div class="withdraw-padding">
          <h3 class="withdraw-step">02绑定账号或确认账号</h3>
          <p>如您还未绑定账号，请先绑定账号</p>
        </div>
        <img src="../assets/images/withdraw2_1.png" alt="">
        <p>如您已绑定账号，点击菜单栏“学费提现”确认账号</p>
        <img src="../assets/images/withdraw2_2.png" alt="">
        <p>如账号不正确，点击“账号绑定”更换绑定账号</p>
        <img src="../assets/images/withdraw2_3.png" alt="">
      </li>
      <li>
        <div class="withdraw-padding">
          <h3 class="withdraw-step">03进入提现页面</h3>
          <p>绑定正确的账号后点击学费提现------进入提现页面</p>
        </div>
        <img src="../assets/images/withdraw3.jpg" alt="">
      </li>
      <li>
        <div class="withdraw-padding">
          <h3 class="withdraw-step">04提现</h3>
          <p>点击“确认提现“，提现成功！</p>
        </div>
        <img src="../assets/images/withdraw4.jpg" alt="">
      </li>
    </ul>
    <div class="withdraw-footer">
      <p>如您在学费提现过程中遇到任何问题和建议，可随时拨打电话进行咨询：<a href="tel:400-800-2211">24小时客服电话：400-800-2211</a></p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
  .withdraw {
    padding: 20px 0 30px;
    font-size: 14px;
    line-height: 22px;
    text-align: left;
    color: #333;

    &-padding {
      padding: 0 30px 0 15px;
    }

    &-nav {
      display: block;
      width: 144px;
      margin: 0 auto 10px;
    }

    &-explain {
      padding-bottom: 15px;
      text-align: center;
      color: #999;
    }

    &-steps {
      li {
        > p {
          padding-left: 20px;
        }
      }

      h3 {
        position: relative;
        height: 24px;
        padding-left: 10px;
        margin-bottom: 5px;
        font-size: 17px;
        font-weight: bolder;
        font-family: "MicrosoftYaHei";
        line-height: 24px;

        &::before {
          position: absolute;
          top: 4px;
          left: 0;
          width: 4px;
          height: 16px;
          background-color: #ff5b2f;
          border-radius: 4px;
          content: '';
        }
      }

      p {
        line-height: 20px;
        color: #999;
      }

      img {
        width: 100%;
        margin: 10px 0 25px;
      }
    }

    &-step {
      height: 32px;
      font-size: 17px;
      font-weight: bolder;
    }

    &-footer {
      text-align: center;
      color: #5f5f5f;

      p {
        padding: 0 15px;

        a {
          height: 22px;
          color: #ff5b2f;
        }
      }

      .withdraw-qcode {
        p {
          padding-bottom: 15px;
        }

        img {
          width: 125px;
        }
      }
    }
  }
</style>
